import React from "react"
import {
  Divider, Flex, Grid, Heading, Stack,
} from "@chakra-ui/react"
import Card from "components/layout/Card"
import VerticalStat from "components/elements/VerticalStat"
import EventLinkDetails from "components/EventLink/EventLinkDetails"
import { DioboxEvent } from "sharedTypes"
import EventImage from "./EventImage"

type Props = {
  event: DioboxEvent
  canViewWebsite: boolean
}

const EventLinkSection = ({ event, canViewWebsite }: Props) => {
  const { website } = event

  return (
    <Card>
      <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={8}>
        <Flex direction="column" gap={6}>
          <Heading fontSize="2xl" fontWeight="semibold">Event Link</Heading>
          <EventLinkDetails event={event} canEdit={canViewWebsite} />
          {canViewWebsite && (
            <Stack spacing={6} mt="auto">
              <Divider />
              <VerticalStat label="Web Page Views" value={website.viewsCount} />
            </Stack>
          )}
        </Flex>
        <EventImage
          eventId={event.id}
          coverImageUrl={website.coverImageUrl}
          canEdit={canViewWebsite}
        />
      </Grid>
    </Card>
  )
}

export default EventLinkSection
